<template>
    <div>
        <div class="profile" v-if="clientId && bookedEvents.length > 0">
            <h2 class="profile__title wow zoomIn" data-wow-duration="1.5s">booked artists</h2>

            <ul class="booked">
                <li
                    class="booked__item wow zoomIn"
                    data-wow-duration="1.5s"
                    v-for="event in bookedEvents"
                    :key="event.id"
                >
                    <div class="booked__left">
                        <div class="booked__image">
                            <img :src="getNameOfAvatar(event.artist.file_avatar.file_path)" alt="Booked Artist Photo" width="142">
                        </div>
                        <div>
                            <h3 class="booked__name"> {{event.artist.stage_name}}</h3>
                            <p
                                class="booked__position m-0"
                                v-for="category in event.artist.categories"
                                :key="category.id"
                            >{{category.name}}</p>
                        </div>
                    </div>
                    <div class="booked__center">
                        <div class="booked__cols">
                            <div class="booked__col">
                                <p class="color_primary ttu mb-2">From / Location</p>
                                <p><b>{{ event.from }}</b></p>
                                <p><b>{{ event.start_location}}</b></p>
                            </div>
                            <div class="booked__col">
                                <p class="color_primary ttu">To / Location</p>
                                <p><b> {{ event.to }}</b></p>
                                <p><b>{{ event.end_location}}</b></p>
                            </div>
                        </div>
                    </div>
                    <div class="booked__right">
                        <a :href="`/client/artist/${event.artist_id}`" class="btn btn_golden"><span>view details</span></a>
                    </div>
                </li>
            </ul>
            <div class="text-center pt-3 wow zoomIn" data-wow-duration="1.5s" v-show="hasMore">
                <a
                    href="javascript:void(0)"
                    class="btn btn_primary-outline"
                    @click="showMoreArtists"
                >Show More</a>
            </div>

        </div>
        <div class="tab-pane" id="second" v-else>
            <div class="categories__empty">
                <svg width="45" height="45">
                    <use href="/img/svg/symbol-defs.svg#icon-cinema"></use>
                </svg>
                <p>There are no booked artists</p>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState} from "pinia";
import {useClientStore} from "../../stores/ClientStore";

export default {
    name: 'BookedArtists',
    data() {
        return {
            page: 1,
            perPage: 10,
        }
    },
    props: {
        clientId: String | Number
    },
    computed: {
        ...mapState(useClientStore, {
            bookedEvents: 'listOfBookedArtists',
            hasMore() {
                return this.bookedEvents.length >= this.perPage;
            }
        })
    },
    methods: {
        ...mapActions(useClientStore, {
            getBookedArtists: 'fetchListOfBookedArtists',
        }),
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
        showMoreArtists() {
            this.page++
            this.getBookedArtists(this.clientId, this.page)
        }
    },
    watch: {
        page(oldVal, newVal) {
            this.getBookedArtists(this.clientId, this.page)
        }
    },
    created() {
        this.getBookedArtists(this.clientId, this.page)
    }
}

</script>

<style scoped>

</style>
